import classes from "./ItemDescription.module.css";
import Button from "./Button";

const ItemDescription = (props) => {
  //itemNumber
  //itemHeader
  //itemDescription
  //itemSpecial?
  //linkText
  //linkURL

  //{props.linkText && <a href={props.linkURL}>{props.linkText}</a>}
  //console.log(props.linkText)
  //console.log(props.linkURL)

  return (
    <div className={classes.itemContainer}>
      <div className={classes.itemNumber}> {props.itemNumber}</div>
      <div className={classes.itemDescriptionContainer}>
        <p className={classes.itemHeader}>{props.itemHeader}</p>

        {props.itemSpecial && (
          <p className={classes.itemSpecial}>
            {props.itemSpecial}
          </p>
        )}
        {props.itemSubheader && (
          <p className={classes.itemSubheader}>{props.itemSubheader}</p>
        )}


        <p className={classes.itemDescription}>{props.itemDescription}</p>
        {props.linkText && (
          <a
            className={classes.linkStyle}
            href={props.linkURL}
            rel="noopener noreferrer"
            target="_blank"
          >
            {props.linkText}
          </a>
        )}

        {props.itemToggle && (
          <Button
            onClick={props.itemToggle}
            buttonText={props.itemToggleText}
            size="small"
          />
        )}        

        {props.linkFunctionText && (
          <button className={classes.button} onClick={props.linkFunction}>
            {props.linkFunctionText}
          </button>
        )}

        {props.itemNotice && <p>{props.itemNotice}</p>}
      </div>
    </div>
  );
};

export default ItemDescription;
